import { buildOptions, getEndPoints } from "../../../utils/api-call";
import { makeCall } from "../../../utils/request";
import { downloadFile } from "../../../utils/download-file";
import * as consts from "./constants";

// import constants from '@/_consts';

export const state = {
  query_results: [],
  query_result: {},
  dummy_chart_data: {},
  chart_data: [],
  chart_raw_data: {},
  incentive_met_data: {},
  wellmetric_participants_data: {},
  last_time_data: {},
  risk_factors_data: [],
  modality_by_type_data: []
};

export const getters = {
  [consts.GETTERS_QUERY_RESULTS_LIST]: state => {
    return state.query_results;
  },
  [consts.GETTERS_DUMMY_CHART_DATA]: state => {
    return state.dummy_chart_data;
  },
  [consts.GETTERS_CHART_DATA]: state => {
    return state.chart_data;
  },
  [consts.GETTERS_CHART_RAW_DATA]: state => {
    return state.chart_raw_data;
  },
  [consts.GETTERS_INCENTIVE_MET_DATA]: state => {
    return state.incentive_met_data;
  },
  [consts.GETTERS_WELLMETRIC_PARTICIPANTS_DATA]: state => {
    return state.wellmetric_participants_data;
  },
  [consts.GETTERS_LAST_TIME_DATA]: state => {
    return state.last_time_data;
  },
  [consts.GETTER_RISK_FACTORS_DATA]: state => {
    return state.risk_factors_data;
  },
  [consts.GETTER_MODALITY_BY_TYPE_DATA]: state => {
    return state.modality_by_type_data;
  }
};

export const actions = {
  [consts.ACTION_GET_QUERY_RESULTS_LIST]: ({ commit }, options) => {
    makeCall(
      getEndPoints().query_results.getList,
      buildOptions("GET", options),
      commit
    ).then(response => {
      if (response.data) {
        commit(consts.MUTATION_SET_QUERY_RESULTS_LIST, response);
      }
    });
  },
  [consts.ACTION_GET_DUMMY_CHART_DATA]: ({ commit }, id) => {
    id = 1;
    const getAllCatUrl = getEndPoints().query_results.getChartDummyData.replace(
      ":id",
      id
    );
    makeCall(getAllCatUrl, buildOptions("GET", {}), commit).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_DUMMY_CHART_DATA, response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [consts.ACTION_GET_CHART_DATA]: ({ commit }, id) => {
    const getChartDataUrl = getEndPoints().query_results.getChartData.replace(
      ":id",
      id
    );
    // console.log(getChartDataUrl);
    makeCall(getChartDataUrl, buildOptions("GET", {}), commit).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_CHART_DATA, { id: id, data: response });
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [consts.ACTION_GET_CHART_RAW_DATA]: ({ commit }, options) => {
    const getChartDataUrl = getEndPoints().query_results.getChartData.replace(
      ":id",
      options.id
    );
    makeCall(
      getChartDataUrl,
      buildOptions("GET", { params: options }),
      commit
    ).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_CHART_RAW_DATA, {
            id: options.id,
            data: response.options
          });
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [consts.ACTION_GET_INCENTIVE_MET_DATA]: ({ commit }, options) => {
    const getChartDataUrl = getEndPoints().query_results.getChartData.replace(
      ":id",
      options.id
    );
    makeCall(
      getChartDataUrl,
      buildOptions("GET", { params: options }),
      commit
    ).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_INCENTIVE_MET_DATA, response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [consts.ACTION_GET_WELLMETRIC_PARTICIPANTS_DATA]: ({ commit }, options) => {
    const getChartDataUrl = getEndPoints().query_results.getChartData.replace(
      ":id",
      options.id
    );
    makeCall(
      getChartDataUrl,
      buildOptions("GET", { params: options }),
      commit
    ).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_WELLMETRIC_PARTICIPANTS_DATA, response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [consts.ACTION_GET_LAST_TIME_DATA]: ({ commit }) => {
    const endpoint = getEndPoints().query_results.lastTimeUpdated;
    makeCall(endpoint, buildOptions("GET", {}), commit).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_LAST_TIME_DATA, response);
        }
      },
      error => {
        console.log("error =", error + endpoint);
      }
    );
  },
  [consts.ACTION_GET_RISK_FACTORS_DATA]: ({ commit }, options) => {
    const getRiskFactorsDataUrl = getEndPoints()
      .query_results.getRiskFactorsData.replace(
        ":employer_name",
        options.employer_name
      )
      .replace(":demo", options.demo);
    // console.log(getRiskFactorsDataUrl);
    makeCall(getRiskFactorsDataUrl, buildOptions("GET", {}), commit).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_RISK_FACTORS_DATA, response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  },
  [consts.ACTION_GET_MODALITY_BY_TYPE_DATA]: ({ commit }, options) => {
    const getModalityByTypeUrl = getEndPoints()
      .query_results.getModalityByType.replace(
        ":employer_name",
        options.employer_name
      )
      .replace(":demo", options.demo);
    makeCall(getModalityByTypeUrl, buildOptions("GET", {}), commit).then(
      response => {
        if (response) {
          commit(consts.MUTATION_SET_MODALITY_BY_TYPE_DATA, response);
        }
      },
      error => {
        console.log("error =", error);
      }
    );
  }
};

export const mutations = {
  [consts.MUTATION_SET_QUERY_RESULTS_LIST]: (state, queryResults) => {
    state.query_results = queryResults.data;
  },
  [consts.MUTATION_SET_DUMMY_CHART_DATA]: (state, data) => {
    state.dummy_chart_data = data;
  },
  [consts.MUTATION_SET_CHART_DATA]: (state, response) => {
    state.chart_data.push({ id: response.id, data: response.data });
  },
  [consts.MUTATION_SET_CHART_RAW_DATA]: (state, response) => {
    state.chart_raw_data = {
      id: response.id,
      data: response.data
    };
  },
  [consts.MUTATION_SET_INCENTIVE_MET_DATA]: (state, response) => {
    state.incentive_met_data = response.options;
  },
  [consts.MUTATION_SET_WELLMETRIC_PARTICIPANTS_DATA]: (state, response) => {
    state.wellmetric_participants_data = response.options;
  },
  [consts.MUTATION_SET_LAST_TIME_DATA]: (state, response) => {
    state.last_time_data = response;
  },
  [consts.MUTATION_SET_RISK_FACTORS_DATA]: (state, response) => {
    state.risk_factors_data = response;
  },
  [consts.MUTATION_SET_MODALITY_BY_TYPE_DATA]: (state, response) => {
    state.modality_by_type_data = response;
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/query_results/index.js